import * as React from "react";
import { forwardRef } from "react";
const SvgXCloseIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "x-close" }, /* @__PURE__ */ React.createElement("path", { id: "Icon", d: "M18 6L6 18M6 6L18 18", stroke: "#667085", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })));
const ForwardRef = forwardRef(SvgXCloseIcon);
export { ForwardRef as ReactComponent };
